import React from 'react';

const About = () => {
    return (
        <div className="container">
            <h1 className="text-start mx-5 my-5 border-bottom">About</h1>
            <h4 className="text-start mx-5 my-5">Welcome to MediNova Health Center</h4>
            <p className="text-start ms-5">We are committed to serving people.  Medinova Diagnostic Center is working diligently to make people live a healthy and happy life. We know that we have a lot of responsibilities and duties towards the country and the nation because everyone believes that  Medinova Diagnostic Center is a place of trust and confidence.</p>
            <h4 className="text-start mx-5 my-5">Our Vision</h4>
            <p className="text-start ms-5">Excellence through innovation is the central concept of our vision. Together with the concept customer satisfaction with persistent relationship is the DNA of our corporate culture. This vision helps us to find the driving way. In a competitive and fast-changing world, the business dynamics are constantly changing. Today only innovation can bring excellence and add value to products and services that can satisfy our customers.</p>

        </div>
    );
};

export default About;